import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Account from "../views/Account.vue";
import Search from "../views/SearchView.vue";
import AddBranch from "../views/AddBranch.vue";
import { usePolicyStatus } from "@/composables/usePolicyStatus";
import { profileCompletion } from "@/services/auth";

const routes = [
  { path: "/",            name: "home",           component: HomeView },
  { path: "/search",      name: "search",         component: Search },
  { path: "/account",     name: "Account",        component: Account },
  { path: '/me/contributions', name: 'MyContributions', component: () => import('@/views/MyContributions.vue'), meta: { requiresAuth: true } },
  { path: '/me/likes', name: 'MyLikes', component: () => import('@/views/MyLikes.vue'), meta: { requiresAuth: true } },
  { path: '/me/bookmarks', name: 'MyBookmarks', component: () => import('@/views/MyBookmarks.vue'), meta: { requiresAuth: true } },
  { path: '/feedback', name: 'Feedback', component: () => import('@/views/FeedbackForm.vue'), meta: { requiresAuth: true } },
  { path: '/points', name: 'Points', component: () => import('@/views/PointsView.vue') },
  { path: "/AddBranch",   name: "AddBranch",      component: AddBranch },
  { path: "/branch/:id",  name: "BranchDetails",  component: () => import("@/views/BranchDetails.vue"), meta: { hideFooter: true } },
  { path: "/branch/:id/share", name: "ShareExperience", component: () => import("@/views/ShareExperience.vue"), meta: { hideFooter: true, requiresAuth: true } },
  { path: "/notifications", name: "Notifications", component: () => import("@/views/Notifications.vue"), meta: { requiresAuth: true } },
  { path: "/branch/:branchId/menu/item/:itemId", name: "MenuItemDetail", component: () => import("@/views/MenuItemDetail.vue") },
  { path: "/branch/:id/visitor-photos", name: "VisitorGallery", component: () => import("@/views/VisitorGallery.vue") },
  { path: "/pages/:slug", name: "StaticPage", component: () => import("@/views/StaticPage.vue"), meta: { public: true } },
  { path: "/pages",       name: "StaticPageIndex", component: () => import("@/views/StaticPageIndex.vue"), meta: { public: true } },
  { path: "/policy-acceptance", name: "PolicyAcceptance", component: () => import("@/views/PolicyAcceptanceView.vue"), meta: { public: true } },
  { path: "/profile", name: "ProfileEdit", component: () => import("@/views/ProfileEdit.vue"), meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Routes that are always accessible — never blocked even with pending policies
const ALWAYS_ALLOW = ["PolicyAcceptance", "StaticPage", "StaticPageIndex", "Account", "ProfileEdit"];

router.beforeEach(async (to) => {
  console.log("[Router] navigating to:", to.name, to.fullPath);

  // Always allow these routes
  if (ALWAYS_ALLOW.includes(to.name)) {
    console.log("[Router] always-allow route, passing through");
    return true;
  }

  const token = localStorage.getItem("token");
  console.log("[Router] token present:", !!token);

  if (!token) {
    if (to.meta?.requiresAuth) return { name: "Account" };
    return true;
  }

  // Token exists — check pending policies
  const { pendingPolicies, checked, checkStatus } = usePolicyStatus();
  console.log("[Router] checked:", checked.value, "| pending:", pendingPolicies.value.length);

  if (!checked.value) {
    console.log("[Router] calling checkStatus...");
    await checkStatus();
    console.log("[Router] after checkStatus, pending:", pendingPolicies.value.length);
  }

  if (pendingPolicies.value.length > 0) {
    console.log("[Router] redirecting to PolicyAcceptance");
    return { name: "PolicyAcceptance", query: { redirect: to.fullPath } };
  }

  // Policies are settled — now enforce profile completion (gender, DOB, …).
  // Server-driven: we read the cached user's profile_completion (refreshed by me()).
  const completion = profileCompletion();
  if (completion && completion.complete === false) {
    console.log("[Router] profile incomplete, redirecting to ProfileEdit gate");
    return { name: "ProfileEdit", query: { gate: "1", redirect: to.fullPath } };
  }

  return true;
});

export default router;